/**
 * Dates are rendered on the server and again on the client, so the format is
 * pinned to one locale and one zone — a viewer's locale would otherwise change
 * the text between the two renders and trip a hydration warning.
 */
const DATE = new Intl.DateTimeFormat('en-GB', {
  day: 'numeric',
  month: 'short',
  year: 'numeric',
  timeZone: 'UTC',
})

/**
 * "1 cable run" / "3 cable runs". The client warns with the same words the
 * server refuses with, so the phrase lives here and nowhere else.
 */
export function plural(count: number, noun: string): string {
  return `${count} ${noun}${count === 1 ? '' : 's'}`
}

/** "4 Sept 2026"; empty for null or an unparseable value. */
export function formatDate(iso: string | null | undefined): string {
  if (!iso) return ''
  const date = new Date(iso)
  return Number.isNaN(date.getTime()) ? '' : DATE.format(date)
}

/**
 * "Verified by ana@crew.id on 4 Sept 2026" / "Verified by the ROUTR team on …"
 * (catalogue rows never expose the verifier's email) / "Not yet checked…".
 */
export function verificationSummary(device: {
  verified: boolean
  verifiedAt: string | null
  verifiedBy: string | null
  workspaceId: string | null
}): string {
  if (!device.verified) return 'Not yet checked against a spec sheet.'
  const date = formatDate(device.verifiedAt)
  const when = date ? ` on ${date}` : ''
  if (device.verifiedBy) return `Verified by ${device.verifiedBy}${when}`
  if (device.workspaceId === null) return `Verified by the ROUTR team${when}`
  return `Verified${when}`
}
